<template>
  <section class="content">
    <div class="container-fluid">
        <div class="row">

          <div class="col-12">

            <div class="card">
              <div class="card-header">
                <h3 class="card-title"> Список магазинов</h3><br>
                <div class="card-tools">

                  <button type="button" class="btn btn-sm btn-primary" @click="$refs.modal.openModal();clearForm()">
                      <i class="fa fa-plus-square"></i>
                      Добавить магазин
                  </button>
                </div>
              </div>
              <!-- /.card-header -->
              <div class="card-body table-responsive p-0">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th @click="getResults(current_page, 'id')" >id
                        <button :tabindex="-1" aria-label="Sort " title="Sort "
                                :class="[ (sort.id=='ASC') ? 'transform' : 'transformold' ]"
                                class="gridjs-th gridjs-th-sort"></button>
                      </th>
                      <th>Название</th>
                      <th>Адрес	</th>
                      <th>Время работы	</th>
                      <th>Телефон</th>
                    </tr>
                  </thead>
                  <tbody>
                     <tr v-for="filial in filials.data" :key="filial.id">
                      <td>{{filial.id}}</td>
                      <td>{{filial.name}}</td>
                      <td>{{filial.adress}}</td>
                      <td>{{filial.time}}</td>
                      <td>{{filial.phone}}</td>
                      <!-- <td><img v-bind:src="'/' + product.photo" width="100" alt="product"></td> -->
                      <td style="text-align: end">

                        <a href="#" @click="editData(filial);$refs.modal.openModal();">
                            <i class="fa fa-edit blue"></i>
                        </a>
                        /
                        <a href="#" @click="deleteFilial(filial)">
                            <i class="fa fa-trash red"></i>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- /.card-body -->
              <div class="card-footer">
                  <pagination :data="filials" @pagination-change-page="getResults" :limit="5">
                      <span slot="prev-nav">&lt; Назад</span>
                      <span slot="next-nav">Вперед &gt;</span>
                  </pagination>
              </div>
            </div>
            <!-- /.card -->
          </div>
        </div>

        <!-- Modal -->
      <right-modal-widget  v-bind:id="'production-edit-modal'" v-bind:title="!editmode?'Создать запись':'Редактировать запись'" ref="modal">


                <form @submit.prevent="editmode ? updateProduct() : createProduct()">
                    <div class="modal-body">
                        <div class="form-group">
                            <label>Название</label>
                            <input v-model="form.name" type="text" name="name"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('name') }" >
                            <has-error :form="form" field="name"></has-error>
                        </div>
                        <div class="form-group">
                            <label>Адрес</label>
                            <input v-model="form.adress" type="text" name="adress"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('adress') }">
                            <has-error :form="form" field="adress"></has-error>
                        </div>
                        <div class="form-group">
                            <label>Время работы	</label>
                            <input v-model="form.time" type="text" name="time"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('time') }">
                            <has-error :form="form" field="time"></has-error>
                        </div>
                        <div class="form-group">
                            <label>Телефон</label>
                            <input v-model="form.phone" type="text" name="phone"
                                   class="form-control" :class="{ 'is-invalid': form.errors.has('phone') }">
                            <has-error :form="form" field="phone"></has-error>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button v-show="editmode" type="submit" class="btn btn-success">Обновить</button>
                        <button v-show="!editmode" type="submit" class="btn btn-primary">Создать</button>
                    </div>
                  </form>
      </right-modal-widget>

    </div>
  </section>
</template>

<script>

    export default {
        data () {
            return {
                editmode: false,
                filials : {},
                form: new Form({
                    id : '',
                    adress : '',
                    name: '',
                    phone: '',
                    time: '',
                }),
              sort: {
                id: 'ASC',
                family: 'ASC',
                work: 'ASC',
                country: 'ASC',
                email: 'ASC',
                language: 'ASC',
              },
                autocompleteItems: [],
              urls: {
                getdata: "api/filial?page=",
                update: "api/filial/",
                create: "api/filial/",
                delete: "api/filial/",
              },
            }
        },
        methods: {
          clearForm() {
                this.form.id = '';
                this.form.adress = '';
                this.form.name = '';
                this.form.phone = '';
                this.form.time = '';
          },
          getResults(page = 1) {
              this.$Progress.start();
              axios.get(this.urls.getdata + page).then(({ data }) => (this.filials = data.data));
              this.$Progress.finish();
          },
          editData(data) {
            this.editmode = true;
            this.form.reset();
            this.form.fill(data);
          },

          editModal(product){
              console.log(product);
              this.editmode = true;
              this.form.reset();
              this.form.fill(product);
          },
          createProduct(){
              this.$Progress.start();

              this.form.post(this.urls.create)
              .then((data)=>{
                if(data.data.success){
                  $('#addNew').modal('hide');

                  Toast.fire({
                        icon: 'success',
                        title: data.data.message
                    });
                  this.$Progress.finish();
                  this.getResults();
                  this.$refs.modal.closeModal();

                } else {
                  Toast.fire({
                      icon: 'error',
                      title: 'Some error occured! Please try again'
                  });

                  this.$Progress.failed();
                }
              })
              .catch(()=>{

                  Toast.fire({
                      icon: 'error',
                      title: 'Some error occured! Please try again'
                  });
              })
          },
          updateProduct(){
              this.$Progress.start();
              this.form.put(this.urls.update + this.form.id)
              .then((response) => {
                  // success
                  $('#addNew').modal('hide');
                  Toast.fire({
                    icon: 'success',
                    title: response.data.message
                  });
                  this.$Progress.finish();
                this.$refs.modal.closeModal();
                this.editmode = false;

                  this.getResults();
              })
              .catch(() => {
                  this.$Progress.fail();
              });

          },
          deleteFilial(data){
              Swal.fire({
                  title: 'Вы хотите удалить?',
                  text: data.name,
                  showCancelButton: true,
                  confirmButtonColor: '#d33',
                  cancelButtonColor: '#3085d6',
                  cancelButtonText: 'Отмена',
                  confirmButtonText: 'Удалить'
                  }).then((result) => {

                      // Send request to the server
                        if (result.value) {
                              this.form.delete(this.urls.delete + data.id).then(()=>{
                                      Swal.fire(
                                      'Удалено',
                                      'Успешно',
                                      'success'
                                      );
                                  // Fire.$emit('AfterCreate');
                                  this.getResults();
                              }).catch((data)=> {
                                  Swal.fire("Failed!", data.message, "warning");
                              });
                        }
                  })
          },

        },
        mounted() {

        },
        created() {
            this.$Progress.start();

            this.getResults();

            this.$Progress.finish();
        },
        filters: {
            truncate: function (text, length, suffix) {
                return text.substring(0, length) + suffix;
            },
        },
        computed: {
          filteredItems() {
            return this.autocompleteItems.filter(i => {
              return i.text.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1;
            });
          },
        },
    }
</script>
